import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SidebarItemComponent } from '../sidebar-item/sidebar-item.component';
import { SidebarStateService } from './sidebar-state.service';

@Component({
  selector: 'nsp-sidebar',
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SidebarItemComponent, TranslatePipe],
  providers: [SidebarStateService],
})
export class SidebarComponent {
  sidebarStateService = inject(SidebarStateService);
  minimised = this.sidebarStateService.minimised;
  settingsOpen = this.sidebarStateService.settingsOpen;

  toggle() {
    this.sidebarStateService.setMinimised(!this.sidebarStateService.minimised());
  }

  toggleSettings() {
    this.sidebarStateService.toggleSettings();
  }
}
